import React from "react";
import { useSelector } from "react-redux";
import { selectFetchingAttributeData } from "state/attributes/selectors";
import LoadingMask from "@ls/react-loading-mask";
import TopBar from "scenes/TopBar";
import Selection from "scenes/Selection";
import AccountGrid from "components/AccountGrid";
import styled from "styled-components";

const Root = styled.div`
  height: 100vh;
  width: 100vw;
  position: relative;
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  flex: 1 1 1px;
`;

const Home = (props) => {
  const loading = useSelector(selectFetchingAttributeData);
  return (
    <>
      <Selection />
      <Root>
        <div>
          <TopBar />
        </div>
        <Content>
          <AccountGrid />
        </Content>
      </Root>
      <LoadingMask
        active={loading}
        zIndex={12}
        showMsg={loading}
        showSpinner={loading}
      />
    </>
  );
};

export default Home;
